import { render, staticRenderFns } from "./RecommenderManagement.vue?vue&type=template&id=4c3f4ab6&scoped=true"
import script from "./RecommenderManagement.vue?vue&type=script&lang=ts"
export * from "./RecommenderManagement.vue?vue&type=script&lang=ts"
import style0 from "./RecommenderManagement.vue?vue&type=style&index=0&id=4c3f4ab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3f4ab6",
  null
  
)

export default component.exports